import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessagesPeopleUserDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "messages-people-user-dollar" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 4.5,
			cy: 6.75,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,17.25V15a3.75,3.75,0,0,0-7.5,0v2.25h1.5l.75,6H6l.75-6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.625,5.25H15a1.341,1.341,0,0,0-.5,2.587l2.654.826a1.341,1.341,0,0,1-.5,2.587H13.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 5.25,
			x2: 15.75,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 12.75,
			x2: 15.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.251,15.748h3v4.5l4.5-4.5h3a1.5,1.5,0,0,0,1.5-1.5v-12a1.5,1.5,0,0,0-1.5-1.5h-12a1.5,1.5,0,0,0-1.5,1.5"
		})
	]
});
export default SvgMessagesPeopleUserDollar;
